<template>
  <div class="setting" v-loading="loading">
    <el-form label-position="left" v-model="form">
      <el-form-item label="是否开启排行榜">
        <el-switch
          v-model="form.is_open"
          active-color="#409EFF"
          inactive-color="#C0CCDA"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="红包排行条数">
        <el-select v-model="form.reward_pack_number" placeholder="请选择条数">
          <el-option label="10" value="10"></el-option>
          <el-option label="20" value="20"></el-option>
          <el-option label="50" value="50"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="粉丝排行条数">
        <el-select v-model="form.fans_pack_number" placeholder="请选择条数">
          <el-option label="10" value="10"></el-option>
          <el-option label="20" value="20"></el-option>
          <el-option label="50" value="50"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可查榜权限">
        <el-checkbox
          border
          label="普通会员"
          v-model="form.identity.primary"
        ></el-checkbox>
        <el-checkbox
          border
          label="VIP会员"
          v-model="form.identity.vip"
        ></el-checkbox>
        <el-checkbox
          border
          label="代言人"
          v-model="form.identity.endorse"
        ></el-checkbox>
        <el-checkbox
          border
          label="商家"
          v-model="form.identity.partnet"
        ></el-checkbox>
        <el-checkbox
          border
          label="经销商"
          v-model="form.identity.bussiness"
        ></el-checkbox>
      </el-form-item>
      <el-button type="primary" @click="editSetting">提交</el-button>
    </el-form>
  </div>
</template>

<script>
import RankApi from "@/api/rank.js";
export default {
  data() {
    return {
      loading: true,
      form: {
        is_open: "false",
        fans_pack_number: 10,
        reward_pack_number: 10,
        identity: {
          primary: false,
          vip: false,
          endorse: false,
          partnet: false,
          bussiness: false,
        },
      },
    };
  },
  components: {},
  created() {
    this.getRankSetting();
  },
  methods: {
    // 获取设置信息
    getRankSetting() {
      let params = {
        key: "rank",
      };
      RankApi.getSetting(params, false).then((res) => {
        this.loading = false;
        // let identity = JSON.parse(identity);
        // 解决后端返回字符串布尔值，前端渲染不出效果问题
        this.form.is_open = JSON.parse(res.data.data.is_open);
        let rs = JSON.parse(res.data.data.identity);
        for (var index in rs) {
          rs[index] = JSON.parse(rs[index]);
        }
        this.form.identity = rs;
        this.form.fans_pack_number = res.data.data.fans_pack_number;
        this.form.reward_pack_number = res.data.data.reward_pack_number;
      });
    },
    editSetting() {
      let params = {
        key: "rank",
        is_open: this.form.is_open,
        fans_pack_number: this.form.fans_pack_number,
        identity: JSON.stringify(this.form.identity),
        reward_pack_number: this.form.reward_pack_number,
      };

      RankApi.setSetting(params, false).then((res) => {
        if (res.code == 1) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
            duration:1500
          });
          setTimeout(()=>{
            this.$router.go(0)
          },1500)
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.setting {
  margin-left: 15px;
  el-el-form-item {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/plus/rank/setting.vue